module.exports = __webpack_public_path__ + "img/toplupe-orange.def11dd.png";